export const setUserDetails = (user) => ({
    type: "SET_USER",
    user
})
export const setLogOut = (user) => ({
    type: "SET_LOGOUT",
    user
})